import React from "react";
import BaseModal, { BaseModalProps } from "./BaseModal";
import styled from "styled-components";

type AlertModalProps = Omit<BaseModalProps, "children"> & {
  confirmText?: string;
  onConfirm?: () => void;
};

const AlertModal: React.FC<AlertModalProps> = ({
  onClose,
  confirmText = "",
  onConfirm,
  ...rest
}) => {
  const handleConfirm = () => {
    onConfirm?.();
    onClose();
  };

  return (
    <BaseModal {...rest}  onClose={onClose}>
      <SingleButton onClick={handleConfirm}>{confirmText}</SingleButton>
    </BaseModal>
  );
};

const SingleButton = styled.button`
  margin-top: 16px;
  display: flex;
  height: 60px;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-radius: 0 0 1rem 1rem;
  background-color: #004b49;
  color: white;
  font-weight: 500;
  border: none;
  cursor: pointer;
`;

export default AlertModal;

